/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { IGuide } from "../interfaces/model/Guides";
import { getZoomValue } from "../selectors/index";

/**
 * Guide Line
 */
export class Guide extends WidgetBase<IGuide> {
	/**
     * Override WidgetBase#render to produce a virtual DOM tree.
     * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
     */
	protected render() {
		const GUIDE_WIDTH = 2;
		const { x1, x2, y1, y2 } = this.properties;
		return (
			<line
				stroke="#FF40FF"
				stroke-width={`${getZoomValue(GUIDE_WIDTH)}`}
				x1={`${x1}`}
				x2={`${x2}`}
				y1={`${y1}`}
				y2={`${y2}`}
			/>
		);
	}
}

export default Guide;
